import { BlocState } from "src/app/shared/bloc/base-bloc";

export abstract class HeaderState extends BlocState {
}

export class HeaderLoggedOutState extends HeaderState {
}